import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ResourceTitle from "./ResourceTitle";

const ResourceTitleConnected = (props) => {
  const { titlePrefix, titleStr } = props;

  return <ResourceTitle titleStr={titleStr} titlePrefix={titlePrefix} />;
};

const mapStateToProps = (state, { titleSelector }) => {
  const titleStr = titleSelector(state);

  return {
    titleStr,
  };
};

ResourceTitleConnected.propTypes = {
  titlePrefix: PropTypes.string,
  titleStr: PropTypes.string,
};

ResourceTitleConnected.defaultProps = {
  titlePrefix: "",
  titleStr: "",
};

export default connect(mapStateToProps, null)(ResourceTitleConnected);
